import React from 'react';
import { connect } from 'react-redux';
import Page from '../Page/Page';
import Table from '../Table/Table';
import { customerListSelector } from '../../../../../../../Organisation/scenes/Customer/CustomerSelectors';

const getTableData = (rawData = []) => {
  const header = [
    { width: 20, name: 'NAME' },
    { width: 20, name: 'EMAIL' },
    { width: 40, name: 'ADDRESS' },
    { width: 20, name: 'PHONE' }
  ];
  const data = rawData.map(item => ({
    id: item.name,
    name: item.name,
    email: item.email,
    address: item.address,
    phone: item.phone
  }));
  return { header, data };
};

const Customer = ({ customerList }) => {
  const { header, data } = getTableData(customerList);
  return (
    <Page dynamic>
      <div className="content">
        <h2>B. Strategic Customers</h2>
        <Table header={header}>
          {data.map(item => (
            <tr key={item.id}>
              <td className="table-content">{item.name}</td>
              <td className="table-content">{item.email}</td>
              <td className="table-content">{item.address}</td>
              <td className="table-content">{item.phone}</td>
            </tr>
          ))}
        </Table>
      </div>
    </Page>
  );
};

const mapStateToProps = state => ({
  customerList: customerListSelector(state)
});

export default connect(mapStateToProps)(Customer);
